import * as React from 'react';
import * as moment from 'moment';

import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { IEvent } from '../../custom/classes/event';
import { connect } from 'react-redux';

import ListMonthsView from 'list-months.view';
import { ICalendarAppState } from '../../redux-state';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

interface IListMonthsExternalProps {
}

interface StateToProps {
    monthsData: IMonth<IEvent>[];
    text: ICalendarAppText;
    isLoading: boolean;
    currentMonth: moment.Moment;
}

export type ListMonthsProps = IListMonthsExternalProps & StateToProps;

export class ListMonthsBase extends React.Component<ListMonthsProps, any> {
    render() {
        return (
            <ListMonthsView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IListMonthsExternalProps): StateToProps {
    return {
        monthsData: state.calendar.events,
        text: state.calendarText,
        isLoading: state.calendar.updating,
        currentMonth: state.calendar.currentDate
    }
}

export default connect<StateToProps>(mapStateToProps)(ListMonthsBase);